import service from '@/utils/request'

export function classList(data) {
  return service({
    url: '/api/class_grade/list',
    method: 'post',
    data
  })
}

export function classAdd(data) {
  return service({
    url: '/api/class_grade/add',
    method: 'post',
    data
  })
}

export function classEdit(data) {
  return service({
    url: '/api/class_grade/edit',
    method: 'post',
    data
  })
}

export function classDelete(data) {
  return service({
    url: '/api/class_grade/delete',
    method: 'post',
    data
  })
}